import React, { useState } from "react";
import { useAuth } from "../../context/AuthContext";
import { Navigate, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Lock, ArrowRight } from "lucide-react";

export default function AdminLogin() {
  const { admin, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  if (admin) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Login effettuato");
      navigate("/admin", { replace: true });
    } catch (err) {
      toast.error(err.response?.data?.detail || "Credenziali errate");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-zinc-950 flex items-center justify-center p-6 relative overflow-hidden">
      <div className="absolute inset-0 halftone-bg opacity-30" />
      <div className="absolute top-0 left-0 right-0 h-3 diagonal-stripes" />
      <div className="absolute bottom-0 left-0 right-0 h-3 diagonal-stripes" />

      <div className="relative w-full max-w-md">
        <div className="text-center mb-8">
          <div className="inline-flex items-center justify-center bg-yellow-400 text-black p-4 mb-4 brutal-shadow-black">
            <Lock className="w-8 h-8" strokeWidth={3} />
          </div>
          <div className="font-jp text-yellow-400 text-xs tracking-widest mb-2">管理 / ADMIN</div>
          <h1 className="font-heading text-5xl uppercase text-white leading-none">
            Pannello<br />
            <span className="text-yellow-400">Daita 'n' Jack</span>
          </h1>
        </div>

        <form
          onSubmit={submit}
          data-testid="admin-login-form"
          className="bg-zinc-900 border-4 border-yellow-400 p-8 space-y-5 brutal-shadow"
        >
          <div>
            <label className="font-heading uppercase text-zinc-300 text-xs tracking-widest mb-2 block">
              Email
            </label>
            <input
              data-testid="login-email"
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full bg-zinc-950 border-2 border-zinc-800 px-4 py-3 text-white focus:border-yellow-400 focus:outline-none font-mono"
              placeholder="admin@daitajack.com"
            />
          </div>
          <div>
            <label className="font-heading uppercase text-zinc-300 text-xs tracking-widest mb-2 block">
              Password
            </label>
            <input
              data-testid="login-password"
              type="password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full bg-zinc-950 border-2 border-zinc-800 px-4 py-3 text-white focus:border-yellow-400 focus:outline-none font-mono"
              placeholder="••••••••"
            />
          </div>
          <button
            type="submit"
            data-testid="login-submit"
            disabled={loading}
            className="w-full bg-yellow-400 text-black font-heading uppercase text-lg py-4 hover:bg-white transition flex items-center justify-center gap-2 disabled:opacity-40"
          >
            {loading ? "Accesso..." : "Entra"} <ArrowRight className="w-5 h-5" strokeWidth={3} />
          </button>
          <a
            href="/"
            data-testid="back-to-site"
            className="block text-center text-zinc-500 hover:text-yellow-400 text-xs uppercase tracking-widest"
          >
            ← Torna al sito
          </a>
        </form>
      </div>
    </div>
  );
}
